import { render, staticRenderFns } from "./DesignTickerNw.vue?vue&type=template&id=615dc314&scoped=true"
import script from "./DesignTickerNw.vue?vue&type=script&lang=js"
export * from "./DesignTickerNw.vue?vue&type=script&lang=js"
import style0 from "./DesignTickerNw.vue?vue&type=style&index=0&id=615dc314&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615dc314",
  null
  
)

export default component.exports